import {
 Component,
 Input,
 ViewChild,
 WritableSignal,
 afterNextRender,
 signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISwiperConfigs } from '@core/models/domains/slider.model';
import { ResidenceUnitComponent } from '../../../residence-unit/residence-unit.component';
import { SharedModule } from '@shared/shared.module';
import { SwiperService } from '@shared/services/swiper-config.service';
@Component({
 selector: 'iho-slider-multisquare-view',
 standalone: true,
 imports: [CommonModule, SharedModule, ResidenceUnitComponent],
 templateUrl: './slider-multisquare-view.component.html',
 styleUrls: ['./slider-multisquare-view.component.scss'],
})
export class SliderMultisquareViewComponent {
 configSwiper: any;
 resetSwiper = signal(true);
 cities: WritableSignal<any[]> = signal([]);
 tabriz: WritableSignal<any> = signal([]);
 mashhad: WritableSignal<any> = signal([]);
 isfihan: WritableSignal<any> = signal([]);
 tehran: WritableSignal<any> = signal([]);
 kish: WritableSignal<any> = signal([]);
 shiraz: WritableSignal<any> = signal([]);
 private _dataSource!: any;

 @Input({ required: true })
 get dataSource(): any {
  return this._dataSource;
 }
 set dataSource(value: any) {
  this.mashhad.set(value.Section.Data.Details.filter((city: any) => city.Id == 54));
  this.tehran.set(value.Section.Data.Details.filter((city: any) => city.Id == 19));
  if (value) this.cities.set(value.Section.Data.Details.filter((city: any) => city.Id !== 19 && city.Id !== 54));

 }

 constructor(private swiperService: SwiperService) {
  afterNextRender(() => {
   this.resetSwiper.set(false);
   setTimeout(() => this.resetSwiper.set(true), 0);
  });
 }

 ngOnInit() {
  let config = {
   slide: 'auto',
   pagination: {
    enabled: false,
    clickable: false,
   },
  };
  this.configSwiper = this.swiperService.SwiperConfig(config);
 }
}
